import React, { useContext } from "react";
import "./Get_started.css";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";

function Get_started() {
  const { language } = useContext(Context);

  return (
    <>
      <section className="Get_started">
        <div className="container">
          <div className="text_holder">
            <h2>{language == 1 ? "GET STARTED" : "COMMENCER"}</h2>
            <p>
              {language == 1 ? (
                <>
                  Ready to begin your international journey? <br />
                  Sign up today to explore hospitality internships and study
                  opportunities with AFIWAY.
                </>
              ) : (
                <>
                  Prêt à commencer votre parcours international ? <br />
                  Inscrivez-vous dès aujourd’hui pour découvrir des stages en
                  hôtellerie et des opportunités d’études avec AFIWAY.
                </>
              )}
            </p>
            {/* <Link to="#" > */}
            <Button className="Get_startted_btn">
              {language == 1 ? "Register Now" : "S'inscrire maintenant"}
            </Button>
            {/* </Link> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default Get_started;
